import { observable } from 'mobx';
import CallingStoreSI from 'stores/CallingStoreSI';
import CallingStore   from 'stores/CallingStore';

// list of districts ids that will use SI
const canaries = [
  '5126918ae9c77f9384000053'
];

export class RootCallingStore {

  @observable callingStore = null;

  constructor() {
    if(!this.callingStore){
      this.setupCallingStore()
    }
  }

  setupCallingStore = () => {
    if (!window.SSUser) return

    if (canaries.includes(window.SSUser.districtID)) {
      try {
        console.log('connected to si');
        this.callingStore = new CallingStoreSI();
      } catch (error) {
        console.error('Failed to load CallingStoreSI:', error);
      }
    } else {
      try {
        console.log('connected to twillio');
        this.callingStore = new CallingStore();

      } catch (error) {
        console.error('Failed to load CallingStore:', error);
      }
    }
  }
}

export default new RootCallingStore()
